"use client";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import type { DefaultComponentProps } from "@/interfaces/common";

export default function ToastProvider({ children }: DefaultComponentProps) {
  return (
    <>
      {children}
      <ToastContainer />
    </>
  );
}
